import {
  Heading,
  Image,
  Flex,
  Box,
  Text,
  Divider,
  useMediaQuery,
} from "@chakra-ui/react";
import Section from "../../Component/Layout/Section";
import PageTitle from "../../Component/Page/PageTitle";
import { theme } from "../../assets/style/theme";
import { responsiveValue } from "../../assets/style/defaultTheme";
import LineBreakOnMobile from "../../Component/Br/LineBreakOnMobile";

const { flexBoxDirection } = responsiveValue;


type Props = {
};

function Partnership({  }: Props) {

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const setionContentWith = isMobile ? '100%' : '76%';
  const buttonStyle = {
    padding: '24px 38px',
    height: '80px'
  }


  return (
    <>
      <PageTitle
        type="big"
        bgPath="donation/bg.jpg"
        title="기업 파트너십"
        description="숲과나눔의 여러 사업들은<br />파트너와의 협력으로 만들어지고 있습니다.<br />환경&middot;안전&middot;보건분야의 성장을 돕고<br />숲과 같이 지속가능한 사회를 만들어 갈<br />파트너를 기다립니다."
      />
    
      <Section  pt={80} pb={80}>
        <Heading as="h1" size={isMobile ? '4xl' : '5xl'} color="b.dgr" pb="12">
          숲과나눔 기업 파트너십 특징
        </Heading>
        <Flex justifyContent="space-between" pb="20" direction={flexBoxDirection}>
          <Box w={setionContentWith} mb={isMobile ? 8 : 0}>
            <Heading size="4xl" color="b.bk">신뢰와 과학에 기반</Heading>
            <Divider color="b.lg" mt="6" mb="6" />
            <Text fontSize="16" color="b.g">
              - 확증편향과 일방적인 주장, 갈등과 비난을 넘어 함께 듣고 함께 고민합니다.<br />
              - 과학의 언어와 신뢰의 마음으로 만납니다.
            </Text>
          </Box>
          <Image src="/images/donation/p01.png" objectFit="contain" maxH="190" />
        </Flex>
        <Flex justifyContent="space-between" pb="20" direction={flexBoxDirection}>
          <Box w={setionContentWith} >
            <Heading size="4xl" color="b.bk">새로운 시대에 맞는<LineBreakOnMobile /> 새로운 지원의 틀</Heading>
            <Divider color="b.lg" mt="6" mb="6" />
            <Text fontSize="16" color="b.g">
            - 규모에 맞는 행정 절차, 관리보다는 파트너로서 함께합니다.<br />
            - 새로운 세대에 맞는 지원을 통해 새로운 시민운동 주체를 발굴하고 다양한 대안을 확장시킵니다.<br />
            - 지원자, 수혜자, 재단이 함께 공동의 미션을 향해 나아갑니다.
            </Text>
          </Box>
          <Image src="/images/donation/p02.png" objectFit="contain" maxH="190" />
        </Flex>
        <Flex justifyContent="space-between" pb="20" direction={flexBoxDirection}>
          <Box w={setionContentWith} >
            <Heading size="4xl" color="b.bk">문제해결형 네트워크<LineBreakOnMobile fallback=", " /> 건강한 지식 생태계 구축</Heading>
            <Divider color="b.lg" mt="6" mb="6" />
            <Text fontSize="16" color="b.g">
            - 기업, 정부, 학계, 시민사회가 문제 제기가 아닌 문제 해결을 위해 만납니다.<br />
            - 지식과 지혜의 공유를 통해 건강한 지식생태계를 구축합니다.
            </Text>
          </Box>
          <Image src="/images/donation/p03.png" objectFit="contain" maxH="190" />
        </Flex>
        <Box bg="b.gr" borderRadius="24px" pt="8" pb="8" pl="10" pr="10">
          <Heading size={isMobile ? '2xl' : '4xl'} color="b.wh" pb="6">숲과나눔은 이렇게 일합니다</Heading>
          <Text fontSize="xl" color="b.wh">
            · 갈등과 분란을 만들기보다 소통하고 상대와의 차이를 이해하며 새로운 방식으로 실행합니다.<br />
            · 독립된 재정을 투명하고 효율적으로 관리하며 보여주기식 사업을 위해 자금을 집행하지 않습니다.<br />
            · 단기적인 시각보다는 장기적이고 단계적인 사고로 함께 만들어 갈 미래를 지향합니다.<br />
            · 보기에 좋은 일을 늘려가며 성장하기보다 꼭 필요한 일을 먼저 기획합니다.<br />
            · 수혜자를 관리 대상이 아닌 파트너로 여기며 신뢰를 바탕으로 공동의 목표를 향해 나아갑니다.<br />
            · 오래된 것을 배제하지 않고, 새로운 것을 적극적으로 받아들이려 노력합니다.
          </Text>
        </Box>
        
        <Divider color="b.lg" mt="20" mb="20" />
        
        <Heading size="4xl" color="b.bk" pb="10">진행과정</Heading>
        <Image src="/images/donation/process.png" />
        
        <Divider color="b.lg" mt="20" mb="20" />
        <Heading size="4xl" color="b.bk" pb="6">문의</Heading>
        <Text fontSize="3xl" color="b.dgr" fontWeight="bold">
          02-6925-4635 <LineBreakOnMobile fallback="/ " />
          <a href="mailto:member@koreashe.org">member@koreashe.org</a>
        </Text>

      </Section>
      
    </>
  );
}

Partnership.defaultProps = {
};

export default Partnership;
